// (c) 2018 Chris Ferdinandi, MIT License, https://gomakethings.com/debouncing-your-javascript-events/
const debounceWithAnimationFrame = fn => {
  let timeout

  return function () {
    const context = this
    const args = arguments

    if (timeout) {
      window.cancelAnimationFrame(timeout)
    }

    timeout = window.requestAnimationFrame(function () {
      fn.apply(context, args)
    })
  }
}

export const debounce = (fn, time = 0) => {
  let timeout
  return (...args) => {
    clearTimeout(timeout)
    timeout = setTimeout(() => {
      fn.apply(this, args)
    }, time)
  }
}

export const getCSSVariable = variableName =>
  getComputedStyle(document.documentElement).getPropertyValue(variableName)

export const setCSSVariable = (variableName, value) => {
  document.documentElement.style.setProperty(variableName, value)
}

export const getInnerWindowHeight = debounceWithAnimationFrame(() => {
  const vh = window.innerHeight * 0.01
  setCSSVariable('--vh', `${vh}px`)
})

// https://gist.github.com/stefanmaric/895f51652060a820e2ee7f164af87948
export const defer = () => {
  const bag = {}
  return Object.assign(
    new Promise((resolve, reject) => Object.assign(bag, { resolve, reject })),
    bag
  )
}

export const wait = (data, time) => new Promise(resolve => setTimeout(() => resolve(data), time))

export const assignBoolValue = (urlParam, initialValue) => {
  if (urlParam === '1') return true
  if (urlParam === '0') return false
  return initialValue
}

export const assignNumericValue = (urlParam, initialValue) => {
  return isNaN(urlParam) ? initialValue : Number(urlParam)
}

export const parseColor = (colorStr, defaultColor = '') => {
  if (!colorStr) return defaultColor

  const s = new Option().style

  // Check if colorStr is a valid color string, (e.g. 'red', 'green')
  s.color = colorStr
  if (s.color !== '') {
    return colorStr
  }

  // Check if colorStr is a valid hex color
  const hexColorStr = `#${colorStr}`
  s.color = hexColorStr
  if (s.color !== '') {
    return hexColorStr
  }

  return defaultColor
}
